const publisherPage = () => {
    let copyIframe = () => {
        // Get the text field
        const textArea = document.getElementById("iframeContent");
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
            alert('Code copied');
        } catch (err) {
            console.error('Unable to copy to clipboard', err);
        }
    }
    window.copyIframe = copyIframe;

    $(document).on('click','.form-submit',function(){
        if($('#name').val() == '' || $('#phone').val() == '' || $('#email').val() == '' || ( !$("#radioButton1").is(':checked') && !$("#radioButton2").is(':checked') ) ){
            $('.validation-alert').removeClass('d-none')
            window.scrollTo(0, 0);
        }else{
            let formId = $(this).data('form_id');
            $('.validation-alert').addClass('d-none')
            $('#name'+formId).val($('#name').val());
            $('#phone'+formId).val($('#phone').val());
            $('#email'+formId).val($('#user_email').val());
            $('#type'+formId).val($("input[type='radio'][name='radio']:checked").val());
            $('#'+formId).submit();
            $('#overlay').show();
        }
    });

    function initMap() {
        const myLatLng = { lat: parseFloat($('#lat').val()), lng: parseFloat($('#long').val()) };
        const map = new google.maps.Map(document.getElementById("map"), {
          zoom: 17,
          center: myLatLng,
        });
      
        new google.maps.Marker({
          position: myLatLng,
          map,
          title: $('#companyName').val(),
        });
      }
      
    window.initMap = initMap;

    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            $('#overlay').hide();
        }
    });

    $(function(){
        if( $('#mapDiv').length > 0){
            initMap();
        }
    });

    $(document).on('click','#downloadReport', function() {
        window.location.href = $(this).data('href');
    });

    $(document).on('change','#name',function(){
        $('#hidden_name').val($(this).val());
    })
    $(document).on('change','#user_email',function(){
        $('#hidden_user_email').val($(this).val());
    })
    $(document).on('change','#phone',function(){
        $('#hidden_phone').val($(this).val());
    })
    $(document).on('change','.owner-class',function(){
        $('#hidden_radio').val($('input[name="radio"]:checked').val());
    })
    
}
export default publisherPage;